export default __webpack_public_path__ + "static/upper1_3-f6c4a1cfd8f40ee2ed99fdd23ad03196.jpg";